
import { SortDirection } from '../../../shared/ui/icons/SortIcon/SortIcon';
import { User, UserRole } from '@myapp/contract';

export const defaultUser: User = {
  id: '',
  name: '',
  email: '',
  roles: ['WORKER'] as UserRole[],
  avatarPath: null,
  archivedAt: null,
};

export interface UsersSearchParams {
  page?: number;
  limit?: number;
  sortOrder?: SortDirection;
  sortField?: keyof User;

  firstName?: string
  lastName?: string;
  email?: string;
  projectId?: number;
}

